// Community Commissioner Management APIs

/**
 * @function ApiClient#AddCommissioner
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} commissionerData
 * @param {any} options = {}
 */
export async function AddCommissioner(cid, commissionerData, options = {}) {
  return await this._post(`/community/${cid}/commissioner`, commissionerData, options);
}

/**
 * @function ApiClient#UpdateCommissioner
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} commissionerData
 * @param {any} options = {}
 */
export async function UpdateCommissioner(cid, commissionerData, options = {}) {
  return await this._put(`/community/${cid}/commissioner`, commissionerData, options);
}

/**
 * @function ApiClient#GetCommissionerList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.sortBy
 * @param {any} params.sortDesc
 * @param {any} params.page
 * @param {any} params.itemsPerPage
 * @param {any} params.search
 * @param {any} options = {}
 */
export async function GetCommissionerList(cid, { sortBy, sortDesc, page, itemsPerPage, search }, options = {}) {
  if (!search) search = "";
  return await this._get(`/community/${cid}/commissioner_list?p=${page}&sb=${sortBy}&sd=${sortDesc}&pp=${itemsPerPage}&ss=${search}`, options);
}

/**
 * @function ApiClient#DeleteCommissioner
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} vID
 * @param {any} options = {}
 */
export async function DeleteCommissioner(cid, vID, options = {}) {
  return await this._delete(`/community/${cid}/commissioner/${vID}`, options);
}

/**
 * @function ApiClient#GetCommunityAdminCanBindCommissionerUserList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetCommunityAdminCanBindCommissionerUserList(cid, options = {}) {
  return await this._get(`/community/${cid}/commissioner/can_bind_user_list`, options);
}

/**
 * @function ApiClient#BindCommissionerUser
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} commissionerID
 * @param {any} userID
 * @param {any} options = {}
 */
export async function BindCommissionerUser(cid, commissionerID, userID, options = {}) {
  return await this._post(`/community/${cid}/commissioner/${commissionerID}/bind/${userID}`, null, options);
}

/**
 * @function ApiClient#UnbindCommissionerUser
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} commissionerID
 * @param {any} options = {}
 */
export async function UnbindCommissionerUser(cid, commissionerID, options = {}) {
  return await this._delete(`/community/${cid}/commissioner/${commissionerID}/bind`, options);
}
